(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lahome-inspiration"] && !Shopify.designMode) return;
  try {
    
/* Lahome Inspiration 2.6 — separate Entryway/Hallway, multiple style tags. */
(function (scope) {
  'use strict';
  const clean = value => String(value == null ? '' : value).trim();
  const escapeHTML = value => clean(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const key = value => clean(value).toLocaleLowerCase('en-US');
  function styleValues(item) {
    const found = new Map();
    [item.style, ...(Array.isArray(item.styles) ? item.styles : [])].forEach(value => {
      const label = clean(value);
      if (label && !found.has(key(label))) found.set(key(label), label);
    });
    return [...found.values()];
  }
  const fieldValues = (item, field) => field === 'style' ? styleValues(item) : [clean(item[field])].filter(Boolean);
  const safeURL = value => {
    const raw = clean(value);
    if (!raw) return '';
    try { const url = new URL(raw, 'https://lahome.example'); return ['https:', 'http:'].includes(url.protocol) ? raw : ''; } catch (_) { return ''; }
  };
  function normalize(items) {
    const seen = new Set();
    return items.filter(item => item && item.id && safeURL(item.image) && safeURL(item.url)).map(item => {
      const scene = {};
      ['id','title','room','color','style','shape','product','colorLabel','srcset','focal','alt'].forEach(field => scene[field] = clean(item[field]));
      scene.styles = styleValues(item);
      scene.image = safeURL(item.image); scene.url = safeURL(item.url);
      scene.width = Math.max(1, Number(item.width) || 1000); scene.height = Math.max(1, Number(item.height) || 1000);
      return scene;
    }).filter(item => { if (seen.has(item.id)) return false; seen.add(item.id); return true; });
  }
  function filterScenes(items, state) {
    return items.filter(item => ['room','color','style','shape'].every(field => !state[field] || fieldValues(item,field).some(value => key(value) === key(state[field]))));
  }
  function paginate(items, requestedPage, size) {
    size = [4,8,12,16].includes(Number(size)) ? Number(size) : 12;
    const pages = Math.ceil(items.length / size);
    const page = Math.min(Math.max(1, Math.floor(Number(requestedPage) || 1)), Math.max(1, pages));
    return {page, pages, total:items.length, items:items.slice((page-1)*size,page*size)};
  }
  function pageNumbers(page, pages) {
    const numbers = [...new Set([1, pages, page-1, page, page+1].filter(n=>n>=1&&n<=pages))].sort((a,b)=>a-b);
    const result=[]; numbers.forEach((n,i)=>{if(i&&n-numbers[i-1]>1)result.push('…');result.push(n)});return result;
  }
  function options(items, field, preferred=[]) {
    const found = new Map(); items.forEach(item=>fieldValues(item,field).forEach(value=>{if(!found.has(key(value)))found.set(key(value),value)}));
    const ordered=[];preferred.forEach(label=>{if(found.has(key(label))){ordered.push(found.get(key(label)));found.delete(key(label))}});
    return ordered.concat([...found.values()].sort((a,b)=>a.localeCompare(b)));
  }
  function extractBatch(html) {
    const match = html.match(/<script\b[^>]*\bdata-lhg-data[^>]*>([\s\S]*?)<\/script>/i);
    if (!match) throw new Error('Scene data missing from section response');
    const data = JSON.parse(match[1]);
    if (!Array.isArray(data.items)) throw new Error('Invalid scene data');
    return data;
  }
  const core = {normalize,filterScenes,paginate,pageNumbers,options,extractBatch,escapeHTML,safeURL};
  if (typeof module !== 'undefined' && module.exports) module.exports=core;
  if (!scope.customElements || scope.customElements.get('lahome-inspiration')) return;

  class LahomeInspiration extends HTMLElement {
    connectedCallback() {
      if(this._active)return;
      const configNode=this.querySelector('[data-lhg-config]'),dataNode=this.querySelector('[data-lhg-data]');
      if(!configNode||!dataNode)return;
      this._active=true;this.lifecycle=new AbortController();this.instanceToken={};
      try {this.config=JSON.parse(configNode.textContent);this.initialBatch=JSON.parse(dataNode.textContent)} catch(e){this._active=false;return}
      this.paramPrefix='lhg_'+this.dataset.sectionId+'_';
      this.state=this.readState();this.items=normalize(this.initialBatch.items||[]);this.ready=false;
      this.grid=this.querySelector('[data-lhg-grid]');this.rooms=this.querySelector('[data-lhg-rooms]');
      this.moreWrap=this.querySelector('[data-lhg-more-wrap]');this.moreButton=this.querySelector('[data-lhg-more]');this.announcement=this.querySelector('[data-lhg-announce]');
      this.grid.id='LahomeGrid-'+this.dataset.sectionId;this.moreButton.setAttribute('aria-controls',this.grid.id);
      this.pagination=this.querySelector('[data-lhg-pagination]');this.count=this.querySelector('[data-lhg-count]');
      this.empty=this.querySelector('[data-lhg-empty]');this.catalogMessage=this.querySelector('[data-lhg-catalog-message]');
      this.addEventListener('click',event=>this.onClick(event),{signal:this.lifecycle.signal});
      this.addEventListener('change',event=>this.onChange(event),{signal:this.lifecycle.signal});
      scope.addEventListener('popstate',()=>{this.state=this.readState();if(this.ready)this.render()},{signal:this.lifecycle.signal});
      scope.addEventListener('pageshow',event=>{if(event.persisted)this.restoreScroll()},{signal:this.lifecycle.signal});
      this.addEventListener('shopify:block:select',event=>{
        if(this.config.source!=='blocks'||!this.ready)return;
        const id=clean(event.detail?.blockId),index=this.items.findIndex(item=>item.id===id);
        if(index<0)return;this.state={room:'',color:'',style:'',shape:'',page:Math.floor(index/this.config.pageSize)+1};this.render();this.scrollToGallery();
      },{signal:this.lifecycle.signal});
      this.measureSizes();
      if(scope.ResizeObserver){this.resizeObserver=new ResizeObserver(()=>this.measureSizes());this.resizeObserver.observe(this.grid)}
      this.initializeCatalog();
    }
    disconnectedCallback(){this._active=false;this.instanceToken=null;this.lifecycle?.abort();this.resizeObserver?.disconnect();this.fetchAbort?.abort()}
    readState(){
      const params=new URL(scope.location.href).searchParams;
      const state={page:Math.max(1,parseInt(params.get(this.paramPrefix+'page'),10)||1)};
      ['room','color','style','shape'].forEach(field=>state[field]=clean(params.get(this.paramPrefix+field)));
      return state;
    }
    writeState(push=true){
      const url=new URL(scope.location.href);
      ['room','color','style','shape','page'].forEach(field=>{
        const value=this.state[field];if(value&&(field!=='page'||value!==1))url.searchParams.set(this.paramPrefix+field,value);else url.searchParams.delete(this.paramPrefix+field);
      });
      if(url.href!==scope.location.href)scope.history[push?'pushState':'replaceState'](null,'',url.href);
    }
    setBusy(busy){
      this.querySelectorAll('[data-lhg-filter], [data-lhg-room], [data-lhg-clear]').forEach(el=>el.disabled=busy);
      this.querySelector('[data-lhg-controls]').setAttribute('aria-busy',String(busy));
      this.moreButton.disabled=busy;
      if(busy){this.pagination.hidden=true;this.moreWrap.hidden=true;}
    }
    async fetchBatch(url, signal){
      const target=new URL(url,scope.location.href);
      if(target.origin!==scope.location.origin)throw new Error('Unexpected data origin');
      target.searchParams.set('section_id',this.dataset.sectionId);target.searchParams.delete('sections');
      const preview=new URL(scope.location.href).searchParams.get('preview_theme_id');if(preview)target.searchParams.set('preview_theme_id',preview);
      const response=await fetch(target.href,{credentials:'same-origin',signal,headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('Catalog request failed: '+response.status);
      return extractBatch(await response.text());
    }
    async initializeCatalog(){
      if(this.loading)return;this.loading=true;this.ready=false;this.setBusy(true);
      this.fetchAbort?.abort();this.fetchAbort=new AbortController();const token=this.instanceToken;
      const timer=setTimeout(()=>this.fetchAbort?.abort(),45000);
      this.querySelector('[data-lhg-retry]').hidden=true;
      let batch=this.initialBatch,all=[];
      try{
        if((Number(batch.pages)||1)>1 || Number(batch.page)>1){
          this.catalogMessage.hidden=false;this.catalogMessage.textContent=this.config.loadingLabel;
          // Yield initial painting before fetching metadata. This never loads other pages' images.
          await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
          if(Number(batch.page)>1){const first=new URL(scope.location.href);first.searchParams.set(batch.pageParam||'page','1');batch=await this.fetchBatch(first,this.fetchAbort.signal)}
        }
        const visited=new Set();
        while(true){
          const page=Number(batch.page)||1;
          if(visited.has(page))throw new Error('Repeated catalog page');visited.add(page);
          all=all.concat(batch.items||[]);
          if(!batch.next)break;
          if(visited.size>40)throw new Error('Catalog is too large for this client-side filtering version');
          batch=await this.fetchBatch(batch.next,this.fetchAbort.signal);
        }
        if(token!==this.instanceToken)return;
        this.items=normalize(all);this.ready=true;this.buildControls();this.catalogMessage.hidden=true;
        this.setBusy(false);this.render();this.restoreScroll();
      }catch(error){
        if(token!==this.instanceToken)return;
        this.catalogMessage.hidden=false;this.catalogMessage.textContent=this.config.errorLabel;
        this.querySelector('[data-lhg-retry]').hidden=false;
        this.count.textContent=''; // Do not present partial results as the full catalog.
      }finally{clearTimeout(timer);if(token===this.instanceToken)this.loading=false}
    }
    buildControls(){
      const preferred=(this.config.roomOrder||'').split(',').map(clean).filter(Boolean).flatMap(label=>key(label)==='entryway & hallway'?['Entryway','Hallway',label]:[label]);
      const rooms=options(this.items,'room',preferred);
      this.rooms.innerHTML=`<button class="lhg__room-button" type="button" data-lhg-room="" aria-pressed="false">${escapeHTML(this.config.allLabel)}</button>`+rooms.map(room=>`<button class="lhg__room-button" type="button" data-lhg-room="${escapeHTML(room)}" aria-pressed="false">${escapeHTML(room)}</button>`).join('');
      ['color','style','shape'].forEach(field=>{
        const select=this.querySelector(`[data-lhg-filter="${field}"]`),values=options(this.items,field);
        select.innerHTML=`<option value="">${escapeHTML(this.config[field+'Label'])}</option>`+values.map(value=>`<option value="${escapeHTML(value)}">${escapeHTML(value)}</option>`).join('');
        select.closest('label').hidden=!values.length;
      });
    }
    onClick(event){
      const room=event.target.closest('[data-lhg-room]'),page=event.target.closest('[data-lhg-page]');
      if(room&&this.ready){this.state.room=room.dataset.lhgRoom;this.state.page=1;this.writeState();this.render();this.focusRoom();return}
      if(event.target.closest('[data-lhg-more]')&&this.ready){
        const oldCount=this.grid.children.length;const filtered=filterScenes(this.items,this.state);
        if(oldCount>=filtered.length)return;
        this.state.page+=1;this.writeState();this.render();
        this.announcement.textContent=(this.config.moreAnnouncement||'Showing {shown} of {total} spaces.').replace('{shown}',this.grid.children.length).replace('{total}',filtered.length);
        if(event.detail===0 || this.moreWrap.hidden)this.grid.children[oldCount]?.querySelector('a')?.focus({preventScroll:true});
        return;
      }
      if(page&&this.ready){event.preventDefault();this.state.page=Number(page.dataset.lhgPage);this.writeState();this.render();this.scrollToGallery();return}
      if(event.target.closest('[data-lhg-clear]')&&this.ready){this.state={room:'',color:'',style:'',shape:'',page:1};this.writeState();this.render();this.focusRoom();return}
      if(event.target.closest('[data-lhg-retry]')){this.initializeCatalog();return}
      if(event.target.closest('.lhg__media[href], .lhg__shop[href]')){
        this.writeState(false);
        try{sessionStorage.setItem(this.scrollKey(),JSON.stringify({url:scope.location.href,y:scope.scrollY,time:Date.now()}))}catch(_){}
      }
    }
    onChange(event){const filter=event.target.closest('[data-lhg-filter]');if(!filter||!this.ready)return;this.state[filter.dataset.lhgFilter]=filter.value;this.state.page=1;this.writeState();this.render()}
    focusRoom(){this.rooms.querySelector('[aria-pressed="true"]')?.focus({preventScroll:true})}
    scrollToGallery(){const el=this.querySelector('[data-lhg-controls]');el.scrollIntoView({block:'start',behavior:scope.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});el.focus({preventScroll:true})}
    scrollKey(){return 'lahome-inspiration-scroll:'+scope.location.pathname+':'+this.dataset.sectionId}
    restoreScroll(){
      try{const stored=JSON.parse(sessionStorage.getItem(this.scrollKey())||'null');
        const nav=scope.performance?.getEntriesByType?.('navigation')?.[0];
        if(stored&&stored.url===scope.location.href&&Date.now()-stored.time<3600000&&nav?.type==='back_forward')requestAnimationFrame(()=>scope.scrollTo(0,stored.y));
      }catch(_){}
    }
    measureSizes(){
      const width=this.grid?.getBoundingClientRect().width;if(!width)return;
      const columns=scope.innerWidth<750?2:scope.innerWidth<1100?3:4;
      const gap=parseFloat(getComputedStyle(this.grid).columnGap)||0;
      this.imageSizes=Math.ceil((width-(columns-1)*gap)/columns)+'px';
      this.grid.querySelectorAll('img').forEach(img=>{if(img.sizes!==this.imageSizes)img.sizes=this.imageSizes});
    }
    card(item,index){
      const e=escapeHTML,linked=!!item.url,tag=linked?'a':'div';
      const tagAttrs=linked?` href="${e(item.url)}" aria-label="${e(this.config.shopLabel)}: ${e(item.product||item.title)}"`:'';
      // Images after the initial server render are loaded on demand for this visible page.
      const eager=index<(scope.innerWidth<750?2:scope.innerWidth<1100?3:4),priority=this.config.priorityFirst&&this.state.page===1&&index===0?'high':'auto';
      return `<article class="lhg__card" data-scene-id="${e(item.id)}"${this.config.source==='blocks'?` data-shopify-editor-block="${e(JSON.stringify({id:item.id,type:'scene'}))}"`:''}><${tag} class="lhg__media"${tagAttrs}><img src="${e(item.image)}"${item.srcset?` srcset="${e(item.srcset)}"`:''} sizes="${e(this.imageSizes||this.config.sizes)}" width="${item.width}" height="${item.height}" alt="${e(item.alt)}" loading="${eager?'eager':'lazy'}" fetchpriority="${priority}" decoding="async" style="object-position:${e(item.focal||'50% 50%')}"><span class="lhg__cta-position" aria-hidden="true"><span class="lhg__cta"><span>${e(this.config.shopLabel||'Shop this rug')}</span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" focusable="false"><path d="M4 12h15m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></span></${tag}></article>`;
    }
    render(){
      const filtered=filterScenes(this.items,this.state),moreMode=this.config.browseMode!=='pages';
      const result=paginate(filtered,this.state.page,this.config.pageSize);this.state.page=result.page;
      const visibleItems=moreMode?filtered.slice(0,result.page*this.config.pageSize):result.items;
      const oldIds=[...this.grid.querySelectorAll('[data-scene-id]')].map(el=>el.dataset.sceneId);
      const newIds=visibleItems.map(item=>item.id);
      if(oldIds.join('|')!==newIds.join('|')){
        // Preserve existing image nodes and their loaded resources when MORE appends a batch.
        const canAppend=moreMode&&oldIds.length<=newIds.length&&oldIds.every((id,i)=>id===newIds[i]);
        if(canAppend)this.grid.insertAdjacentHTML('beforeend',visibleItems.slice(oldIds.length).map((item,i)=>this.card(item,oldIds.length+i)).join(''));
        else this.grid.innerHTML=visibleItems.map((item,i)=>this.card(item,i)).join('');
      }
      this.grid.hidden=!result.total;this.empty.hidden=!!result.total;
      this.count.hidden=!this.config.showCount;
      this.count.textContent=result.total?`${moreMode?1:(result.page-1)*this.config.pageSize+1}–${Math.min(result.page*this.config.pageSize,result.total)} / ${result.total} ${this.config.spacesLabel}`:`0 ${this.config.spacesLabel}`;
      this.rooms.querySelectorAll('[data-lhg-room]').forEach(button=>button.setAttribute('aria-pressed',String(key(button.dataset.lhgRoom)===key(this.state.room))));
      ['color','style','shape'].forEach(field=>{const select=this.querySelector(`[data-lhg-filter="${field}"]`);const option=[...select.options].find(option=>key(option.value)===key(this.state[field]));select.value=option?option.value:''});
      this.querySelector('[data-lhg-clear]').hidden=!['room','color','style','shape'].some(field=>this.state[field]);
      this.moreWrap.hidden=!moreMode||visibleItems.length>=result.total;
      this.moreButton.disabled=!this.ready||this.moreWrap.hidden;
      this.pagination.hidden=moreMode||result.pages<=1;this.pagination.innerHTML='';
      if(!moreMode&&result.pages>1){
        const link=(page,label,current=false)=>{
          const url=new URL(scope.location.href);url.searchParams.set(this.paramPrefix+'page',page);
          return `<a class="lhg__page" href="${escapeHTML(url.pathname+url.search)}" data-lhg-page="${page}"${current?' aria-current="page"':''}>${escapeHTML(label)}</a>`;
        };
        let html=result.page>1?link(result.page-1,this.config.previousLabel):'';
        html+=pageNumbers(result.page,result.pages).map(page=>page==='…'?'<span aria-hidden="true">…</span>':link(page,page,page===result.page)).join('');
        html+=result.page<result.pages?link(result.page+1,this.config.nextLabel):'';this.pagination.innerHTML=html;
      }
      this.measureSizes();
    }
  }
  scope.customElements.define('lahome-inspiration',LahomeInspiration);
})(typeof window!=='undefined'?window:globalThis);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-sale"]) return;
  try {
    
(() => {
  if (customElements.get('lahome-sale-collection-v5')) return;

  const isCatalogParam = name => name === 'sort_by' || /^page(?:_|$)/.test(name) || name.startsWith('filter.');
  const pathKey = url => url.pathname.replace(/\/+$/, '');

  class LahomeSaleCollection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.results = this.querySelector('[data-lh-sale-results]');
      if (!this.results) return;
      this.ready = true;
      this.sequence = 0;
      this.pendingURL = null;
      this.entryPage = new URL(location.href);
      this.entryCollection = new URL(this.dataset.collectionUrl, location.origin);
      this.activeURL = new URL(this.entryCollection);
      for (const [key, value] of this.entryPage.searchParams) {
        if (isCatalogParam(key)) this.activeURL.searchParams.append(key, value);
      }
      this.tabs = Array.from(this.querySelectorAll('[data-lh-sale-tab]'));
      this.allowedCollections = new Map([[pathKey(this.entryCollection), this.entryCollection]]);
      this.tabs.forEach(tab => {
        const url = new URL(tab.href, location.origin);
        if (url.origin === location.origin) this.allowedCollections.set(pathKey(url), url);
      });
      // A template preview can use an unrelated collection (e.g. Best Sellers).
      // Load the configured first category; never mark Sale over unrelated cards.
      const entryTab = this.tabs.find(tab => pathKey(new URL(tab.href)) === pathKey(this.entryCollection));
      this.defaultCollection = entryTab || !this.tabs.length ? this.entryCollection : new URL(this.tabs[0].href);
      this.cache = new Map();
      this.cacheBytes = 0;
      this.resultsDirty = false;
      this.domCache = new Map();
      this.domCacheBytes = 0;
      this.domCacheElements = 0;
      this.domCacheLimit = navigator.deviceMemory && navigator.deviceMemory <= 2 ? 1 : 2;
      this.warmAttempts = new Set();
      this.warmTimer = null;
      this.warmIdle = null;
      this.warmVisible = !('IntersectionObserver' in window);
      // The live All Sale markup alone is about 3.3 MB as a UTF-16 string.
      // Bound memory, retain the return tab, and keep the original 60-second TTL.
      this.cacheLimit = 16 * 1024 * 1024;
      this.homeCacheKey = this.cacheKey(this.tabs[0] ? new URL(this.tabs[0].href) : this.entryCollection);
      this.fullPageFallback = new Set();
      this.remember(this.activeURL, this.results);
      this.activeExpires = this.cacheEntry(this.activeURL)?.expires || Date.now() + 60000;
      this.status = this.querySelector('[data-lh-sale-status]');
      this.errorBox = this.querySelector('[data-lh-sale-error]');
      this.description = this.querySelector('[data-lh-sale-description]');
      this.tabList = this.querySelector('[data-lh-sale-tab-list]');
      this.tabNav = this.tabList?.closest('.lh-sale-tabs');
      this.tabGesture = null;
      this.suppressTabClickUntil = 0;
      this.filterOpen = this.dataset.filtersCollapsed === 'false' && window.matchMedia('(min-width: 768px)').matches;
      this.lastPageURL = location.href;
      this.listeners = new AbortController();
      const capture = { capture: true, signal: this.listeners.signal };
      this.addEventListener('click', event => this.onClick(event), capture);
      this.addEventListener('change', event => this.onChange(event), capture);
      this.addEventListener('input', event => {
        if (event.target instanceof Element && this.results.contains(event.target) && isCatalogParam(event.target.name || '')) this.resultsDirty = true;
      }, { signal: this.listeners.signal });
      this.addEventListener('submit', event => this.onSubmit(event), capture);
      this.addEventListener('reset', event => this.onReset(event), capture);
      this.addEventListener('pointerover', event => this.schedulePrefetch(event), { signal: this.listeners.signal });
      this.addEventListener('focusin', event => this.schedulePrefetch(event), { signal: this.listeners.signal });
      this.addEventListener('pointerout', event => {
        const tab = event.target.closest?.('[data-lh-sale-tab]');
        if (tab && !tab.contains(event.relatedTarget)) {
          clearTimeout(this.prefetchDelay);
          this.scheduleWarmup();
        }
      }, { signal: this.listeners.signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.filterOpen) {
          this.stop(event);
          this.setFilterOpen(false, true);
        }
      }, capture);
      window.addEventListener('popstate', () => this.restore(), { signal: this.listeners.signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.cancelWarmup();
          if (!this.pendingURL) this.cancelPrefetch();
          this.pruneCache();
        } else this.scheduleWarmup();
      }, { signal: this.listeners.signal });
      window.addEventListener('load', () => this.scheduleWarmup(), { once: true, signal: this.listeners.signal });
      navigator.connection?.addEventListener?.('change', () => {
        this.cancelWarmup();
        if (!this.canPrefetch(true) && !this.pendingURL) this.cancelPrefetch();
        this.scheduleWarmup();
      }, { signal: this.listeners.signal });
      if ('IntersectionObserver' in window) {
        this.warmObserver = new IntersectionObserver(entries => {
          this.warmVisible = entries.some(entry => entry.isIntersecting);
          if (this.warmVisible) this.scheduleWarmup();
          else {
            this.cancelWarmup();
            if (this.prefetch?.background && !this.pendingURL) this.cancelPrefetch();
          }
        });
        this.warmObserver.observe(this);
      }
      this.tabList?.addEventListener('scroll', () => {
        this.updateTabScroll();
        this.cancelWarmup();
        this.scheduleWarmup();
      }, { passive: true, signal: this.listeners.signal });
      this.tabList?.addEventListener('pointerdown', event => this.startTabDrag(event), { signal: this.listeners.signal });
      window.addEventListener('pointermove', event => this.moveTabDrag(event), { passive: false, signal: this.listeners.signal });
      window.addEventListener('pointerup', event => this.endTabDrag(event), { signal: this.listeners.signal });
      window.addEventListener('pointercancel', event => this.endTabDrag(event), { signal: this.listeners.signal });
      window.addEventListener('blur', () => this.endTabDrag(), { signal: this.listeners.signal });
      this.tabList?.addEventListener('lostpointercapture', event => this.endTabDrag(event), { signal: this.listeners.signal });
      this.tabList?.addEventListener('dragstart', event => {
        if (this.canDragTabs()) event.preventDefault();
      }, { signal: this.listeners.signal });
      this.tabList?.addEventListener('focusin', event => this.revealTab(event.target.closest?.('[data-lh-sale-tab]')), { signal: this.listeners.signal });
      if (this.tabList && 'ResizeObserver' in window) {
        this.tabObserver = new ResizeObserver(() => this.updateTabScroll());
        this.tabObserver.observe(this.tabList);
      }
      window.addEventListener('resize', () => this.updateTabScroll(), { passive: true, signal: this.listeners.signal });
      this.updateTabScroll();
      this.setFilterOpen(this.filterOpen);
      this.selectTab(this.activeURL);
      this.restore(true);
      this.scheduleWarmup();
    }

    disconnectedCallback() {
      this.sequence += 1;
      this.request?.abort();
      clearTimeout(this.loadingDelay);
      clearTimeout(this.requestTimer);
      this.pendingURL = null;
      this.cancelWarmup();
      this.cancelPrefetch();
      this.warmObserver?.disconnect();
      this.tabObserver?.disconnect();
      this.endTabDrag();
      this.cache?.clear();
      this.cacheBytes = 0;
      this.domCache?.clear();
      this.domCacheBytes = 0;
      this.domCacheElements = 0;
      this.listeners?.abort();
      this.classList.remove('lh-sale-is-loading');
      if (this.results) {
        this.results.inert = false;
        this.results.removeAttribute('aria-busy');
      }
      this.tabs?.forEach(tab => tab.classList.remove('is-pending'));
      this.ready = false;
    }

    stop(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    selectTab(url) {
      let selected = null;
      this.tabs.forEach(tab => {
        const active = !selected && pathKey(new URL(tab.href)) === pathKey(url);
        if (active) { tab.setAttribute('aria-current', 'page'); selected = tab; }
        else tab.removeAttribute('aria-current');
      });
      this.updateDescription();
      this.revealTab(selected);
      this.updateTabScroll();
    }

    revealTab(selected) {
      if (selected && this.tabList && !this.tabGesture && this.tabNav?.dataset.mobileLayout !== 'wrap') {
        const list = this.tabList.getBoundingClientRect();
        const item = selected.getBoundingClientRect();
        if (item.left < list.left) this.tabList.scrollBy({ left: item.left - list.left - 4, behavior: 'auto' });
        else if (item.right > list.right) this.tabList.scrollBy({ left: item.right - list.right + 4, behavior: 'auto' });
      }
    }

    updateTabScroll() {
      if (!this.tabList || !this.tabNav) return;
      const scroll = this.tabNav.dataset.mobileLayout !== 'wrap';
      const overflow = scroll && this.tabList.scrollWidth > this.tabList.clientWidth + 2;
      this.tabNav.classList.toggle('has-overflow', overflow);
      const offset = Math.abs(this.tabList.scrollLeft);
      this.tabNav.classList.toggle('is-at-start', !overflow || offset <= 2);
      this.tabNav.classList.toggle('is-at-end', !overflow || offset >= this.tabList.scrollWidth - this.tabList.clientWidth - 2);
    }

    canDragTabs() {
      return Boolean(this.tabList && this.tabNav?.dataset.mobileLayout !== 'wrap' &&
        this.tabList.scrollWidth > this.tabList.clientWidth + 2 &&
        ['auto', 'scroll'].includes(getComputedStyle(this.tabList).overflowX));
    }

    startTabDrag(event) {
      // Touch scrolling stays native: preserve inertia, vertical page scrolling,
      // and pinch zoom. Mouse/pen dragging also works in the theme editor iframe.
      if (event.isPrimary !== false && event.button === 0) this.suppressTabClickUntil = 0;
      if (event.pointerType === 'touch' || event.isPrimary === false || event.button !== 0 ||
          event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.canDragTabs()) return;
      this.tabGesture = {
        id: event.pointerId, startX: event.clientX, startY: event.clientY,
        startScroll: this.tabList.scrollLeft, dragging: false
      };
    }

    moveTabDrag(event) {
      const gesture = this.tabGesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      if (event.buttons === 0) { this.endTabDrag(event); return; }
      const dx = event.clientX - gesture.startX;
      const dy = event.clientY - gesture.startY;
      if (!gesture.dragging) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { this.tabGesture = null; return; }
        gesture.dragging = true;
        this.cancelWarmup();
        this.cancelPrefetch();
        this.tabList.classList.add('is-dragging');
        try { this.tabList.setPointerCapture(event.pointerId); } catch (_) { /* The window listeners still finish a drag. */ }
      }
      if (event.cancelable) event.preventDefault();
      this.tabList.scrollLeft = gesture.startScroll - dx;
      this.updateTabScroll();
    }

    endTabDrag(event) {
      const gesture = this.tabGesture;
      if (!gesture || (event && event.pointerId !== gesture.id)) return;
      this.tabGesture = null;
      this.tabList?.classList.remove('is-dragging');
      if (gesture.dragging) this.suppressTabClickUntil = Date.now() + 450;
      try {
        if (this.tabList?.hasPointerCapture(gesture.id)) this.tabList.releasePointerCapture(gesture.id);
      } catch (_) { /* Capture may already be released by pointercancel. */ }
      this.updateTabScroll();
      this.scheduleWarmup();
    }

    cacheKey(url) {
      const key = this.endpoint(url);
      key.searchParams.sort();
      return key.href;
    }

    dropDOM(key) {
      const entry = this.domCache.get(key);
      if (!entry) return;
      this.domCacheBytes -= entry.bytes;
      this.domCacheElements -= entry.elements;
      this.domCache.delete(key);
    }

    rememberDOM(url, node, expires) {
      // Never retain a mounted panel or an opened/in-flight quick-buy form.
      if (!node || (node.ownerDocument === document && node.isConnected) || expires <= Date.now()) return;
      const key = this.cacheKey(url);
      const raw = this.cacheEntry(url);
      if (!raw || raw.bytes > 8 * 1024 * 1024 || node.querySelector('.product-block.expanded, .quickbuy-container .inner:not(:empty), dialog[open], [aria-busy="true"]')) return;
      const elements = node.querySelectorAll('*').length;
      if (elements > 14000) return;
      this.dropDOM(key);
      node.inert = false;
      node.removeAttribute('aria-busy');
      // A template keeps newly prefetched cards inert: no product constructors or
      // offscreen image loading, and no full fallback document retained in memory.
      if (node.ownerDocument !== document) {
        const parking = document.createElement('template');
        parking.content.appendChild(node);
      }
      this.domCache.set(key, { node, expires: Math.min(expires, raw.expires), bytes: raw.bytes, elements });
      this.domCacheBytes += raw.bytes;
      this.domCacheElements += elements;
      while (this.domCache.size > this.domCacheLimit || this.domCacheBytes > 8 * 1024 * 1024 || this.domCacheElements > 14000) {
        const oldest = [...this.domCache.keys()].find(candidate => candidate !== this.homeCacheKey) || this.domCache.keys().next().value;
        this.dropDOM(oldest);
      }
    }

    cachedDOM(url) {
      const key = this.cacheKey(url);
      const entry = this.domCache.get(key);
      if (!entry) return null;
      if (entry.expires <= Date.now()) { this.dropDOM(key); return null; }
      this.domCache.delete(key);
      this.domCache.set(key, entry);
      return entry.node;
    }

    dropCache(key) {
      this.dropDOM(key);
      const entry = this.cache.get(key);
      if (!entry) return;
      this.cacheBytes -= entry.bytes;
      this.cache.delete(key);
    }

    pruneCache() {
      const now = Date.now();
      for (const [key, entry] of this.cache) {
        if (entry.expires <= now) this.dropCache(key);
      }
      for (const [key, entry] of this.domCache) {
        if (entry.expires <= now) this.dropDOM(key);
      }
    }

    remember(url, incoming) {
      if (!this.cache) return;
      const html = incoming.outerHTML;
      if (!html) return;
      const bytes = html.length * 2;
      const key = this.cacheKey(url);
      this.pruneCache();
      this.dropCache(key);
      if (bytes > this.cacheLimit) return;
      this.cache.set(key, { html, bytes, expires: Date.now() + 60000 });
      this.cacheBytes += bytes;
      while (this.cache.size > 8 || this.cacheBytes > this.cacheLimit) {
        // Keep All Sale when possible; neither its TTL nor the budget is bypassed.
        const oldest = [...this.cache.keys()].find(candidate => candidate !== this.homeCacheKey) || this.cache.keys().next().value;
        this.dropCache(oldest);
      }
      const entry = this.cache.get(key);
      if (entry && incoming.nodeType === 1) this.rememberDOM(url, incoming, entry.expires);
    }

    cacheEntry(url) {
      if (!this.cache) return null;
      const key = this.cacheKey(url);
      const entry = this.cache.get(key);
      if (!entry) return null;
      if (entry.expires <= Date.now()) { this.dropCache(key); return null; }
      return entry;
    }

    cached(url) {
      const entry = this.cacheEntry(url);
      if (!entry) return null;
      // Parse only when displaying a cached result, never on hover/cache lookup.
      const template = document.createElement('template');
      template.innerHTML = entry.html;
      const result = template.content.querySelector('[data-lh-sale-results]');
      const key = this.cacheKey(url);
      if (!result) { this.dropCache(key); return null; }
      this.cache.delete(key); this.cache.set(key, entry);
      return result;
    }

    canPrefetch(background = false) {
      const connection = navigator.connection;
      return this.isConnected && !document.hidden && navigator.onLine !== false && !this.pendingURL && !this.tabGesture &&
        (background || window.matchMedia('(hover: hover) and (pointer: fine)').matches) &&
        !connection?.saveData && !['slow-2g', '2g', '3g'].includes(connection?.effectiveType);
    }

    cancelWarmup() {
      clearTimeout(this.warmTimer);
      if (this.warmIdle !== null) window.cancelIdleCallback?.(this.warmIdle);
      this.warmTimer = null;
      this.warmIdle = null;
    }

    canWarmup() {
      return this.ready && this.warmVisible && document.readyState === 'complete' && !window.Shopify?.designMode &&
        !this.failedRequest && !this.prefetch && this.warmAttempts.size < 2 && this.canPrefetch(true);
    }

    scheduleWarmup() {
      if (this.warmTimer !== null || this.warmIdle !== null || !this.canWarmup()) return;
      // At most two automatic attempts per page visit, one request at a time.
      // Hover/focus requests and actual clicks always take precedence.
      this.warmTimer = setTimeout(() => {
        this.warmTimer = null;
        if (!this.canWarmup()) return;
        const run = () => {
          this.warmIdle = null;
          this.warmTimer = null;
          if (!this.canWarmup()) return;
          const index = this.tabs.findIndex(tab => pathKey(new URL(tab.href)) === pathKey(this.activeURL));
          for (let offset = 1; offset <= this.tabs.length; offset += 1) {
            const tab = this.tabs[(Math.max(index, 0) + offset) % this.tabs.length];
            const url = this.catalogURL(new URL(tab.href));
            const key = this.cacheKey(url);
            if (url.href === this.activeURL.href || this.cacheEntry(url) || this.warmAttempts.has(key)) continue;
            this.warmAttempts.add(key);
            this.prefetchTab(url, true);
            break;
          }
        };
        if ('requestIdleCallback' in window) this.warmIdle = window.requestIdleCallback(run);
        else this.warmTimer = setTimeout(run, 250);
      }, 2000);
    }

    waitForPrefetchIdle(url, signal) {
      if (this.pendingURL === url.href) return Promise.resolve();
      return new Promise((resolve, reject) => {
        let idle = null;
        let timer = null;
        let settled = false;
        const work = this.prefetch?.controller.signal === signal ? this.prefetch : null;
        const finish = error => {
          if (settled) return;
          settled = true;
          if (idle !== null) window.cancelIdleCallback?.(idle);
          clearTimeout(timer);
          signal.removeEventListener('abort', abort);
          if (work?.resumeParse === resume) delete work.resumeParse;
          if (error) reject(error); else resolve();
        };
        const resume = () => finish();
        const abort = () => finish(new DOMException('Aborted', 'AbortError'));
        if (signal.aborted) { abort(); return; }
        if (work) work.resumeParse = resume;
        signal.addEventListener('abort', abort, { once: true });
        if ('requestIdleCallback' in window) idle = window.requestIdleCallback(resume, { timeout: 1000 });
        else timer = setTimeout(resume, 0);
      });
    }

    schedulePrefetch(event) {
      if (!this.canPrefetch() || (event.type === 'pointerover' && event.pointerType !== 'mouse')) return;
      const tab = event.target.closest?.('[data-lh-sale-tab]');
      if (!tab || !this.tabs.includes(tab) || tab.contains(event.relatedTarget)) return;
      this.cancelWarmup();
      clearTimeout(this.prefetchDelay);
      this.prefetchDelay = setTimeout(() => this.prefetchTab(new URL(tab.href)), 160);
    }

    cancelPrefetch() {
      clearTimeout(this.prefetchDelay);
      if (this.prefetch) {
        clearTimeout(this.prefetch.timer);
        this.prefetch.controller.abort();
      }
      this.prefetch = null;
    }

    prefetchTab(raw, background = false) {
      if (!this.canPrefetch(background)) return;
      const url = this.catalogURL(raw);
      if (url.href === this.activeURL.href || this.cacheEntry(url) || this.prefetch?.url === url.href) {
        this.scheduleWarmup();
        return;
      }
      this.cancelPrefetch();
      const controller = new AbortController();
      const work = { url: url.href, controller, background };
      this.prefetch = work;
      work.timer = setTimeout(() => controller.abort(), 10000);
      work.promise = this.fetchResults(url, controller.signal, true).then(incoming => {
        if (!controller.signal.aborted && this.isConnected) this.remember(url, incoming);
        return incoming;
      }).finally(() => {
        clearTimeout(work.timer);
        if (this.prefetch === work) this.prefetch = null;
        this.scheduleWarmup();
      });
      // A speculative failure must remain silent; a clicked tab has its own retry UI.
      work.promise.catch(() => {});
    }

    async getResults(url, signal) {
      const cached = this.cachedDOM(url) || this.cached(url);
      if (cached) return cached;
      const work = this.prefetch?.url === url.href ? this.prefetch : null;
      if (work) {
        // Promote an intent-prefetch to a real request with a fresh click timeout.
        clearTimeout(work.timer);
        work.resumeParse?.();
        const abort = () => work.controller.abort();
        signal.addEventListener('abort', abort, { once: true });
        try { return await work.promise; }
        catch (error) {
          if (signal.aborted) throw error;
          // A failed speculative request must not make the user's click fail.
        } finally {
          signal.removeEventListener('abort', abort);
          if (this.prefetch === work) this.prefetch = null;
        }
      }
      const incoming = await this.fetchResults(url, signal);
      if (!signal.aborted && this.isConnected) this.remember(url, incoming);
      return incoming;
    }

    setFilterOpen(open, returnFocus = false) {
      const panel = this.results.querySelector('[data-lh-sale-filter-panel]');
      const catalog = this.results.querySelector('[data-lh-sale-catalog]');
      const toggle = this.results.querySelector('[data-lh-sale-filter-toggle]');
      this.filterOpen = Boolean(open && panel);
      if (panel) panel.hidden = !this.filterOpen;
      catalog?.classList.toggle('is-filter-open', this.filterOpen);
      toggle?.setAttribute('aria-expanded', String(this.filterOpen));
      if (returnFocus) toggle?.focus({ preventScroll: true });
    }

    updateDescription() {
      if (!this.description) return;
      const selected = this.tabs.find(tab => tab.getAttribute('aria-current') === 'page');
      const text = selected?.dataset.description?.trim() || '';
      this.description.textContent = text;
      this.description.hidden = !text;
    }

    setMobileColumns(columns) {
      const grid = this.results.querySelector('.product-grid');
      if (grid) {
        for (const name of [...grid.classList]) if (name.startsWith('product-grid--per-row-mob-')) grid.classList.remove(name);
        grid.classList.add('product-grid--per-row-mob-' + columns);
      }
      this.results.querySelectorAll('[data-lh-sale-layout]').forEach(button => {
        const active = button.dataset.lhSaleLayout === columns;
        button.classList.toggle('layout-switch--active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    isAllowed(url) {
      return url.origin === location.origin && this.allowedCollections.has(pathKey(url));
    }

    catalogURL(raw) {
      const url = new URL(raw, this.activeURL);
      if (!this.isAllowed(url)) throw new Error('Unexpected collection URL');
      for (const key of [...url.searchParams.keys()]) {
        if (!isCatalogParam(key)) url.searchParams.delete(key);
      }
      url.hash = '';
      return url;
    }

    endpoint(url, singleSection = true) {
      const requestURL = this.catalogURL(url);
      requestURL.searchParams.set('view', this.dataset.saleView);
      if (singleSection) requestURL.searchParams.set('section_id', this.dataset.sectionId);
      for (const name of ['preview_theme_id', '_fd', 'pb', 'country', 'currency']) {
        const value = this.entryPage.searchParams.get(name);
        if (value !== null) requestURL.searchParams.set(name, value);
      }
      return requestURL;
    }

    pageURL(target) {
      const url = new URL(this.entryPage);
      for (const key of [...url.searchParams.keys()]) {
        if (isCatalogParam(key) || ['sale_collection', 'section_id', 'sections'].includes(key)) url.searchParams.delete(key);
      }
      if (pathKey(target) !== pathKey(this.entryCollection)) {
        url.searchParams.set('sale_collection', target.pathname.split('/').filter(Boolean).pop());
      }
      for (const [key, value] of target.searchParams) {
        if (isCatalogParam(key)) url.searchParams.append(key, value);
      }
      url.hash = '';
      return url;
    }

    targetFromPage() {
      const page = new URL(location.href);
      const handle = page.searchParams.get('sale_collection');
      let target = this.defaultCollection || this.entryCollection;
      if (handle) {
        const found = [...this.allowedCollections.values()].find(url => url.pathname.split('/').filter(Boolean).pop() === handle);
        if (!found) return null;
        target = found;
      }
      const url = new URL(target);
      url.search = '';
      for (const [key, value] of page.searchParams) if (isCatalogParam(key)) url.searchParams.append(key, value);
      return url;
    }

    restore(initial = false) {
      const target = this.targetFromPage();
      if (!target) return;
      if (initial && target.href === this.activeURL.href) return;
      this.load(target, { historyMode: 'none', kind: 'history' });
    }

    onClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!(event.target instanceof Element)) return;
      if (event.detail !== 0 && this.tabList?.contains(event.target) && Date.now() < this.suppressTabClickUntil) {
        this.suppressTabClickUntil = 0;
        this.stop(event);
        return;
      }
      const filterToggle = event.target.closest('[data-lh-sale-filter-toggle]');
      if (filterToggle && this.results.contains(filterToggle)) {
        this.stop(event);
        this.setFilterOpen(!this.filterOpen);
        return;
      }
      const filterClose = event.target.closest('[data-lh-sale-filter-close]');
      if (filterClose && this.results.contains(filterClose)) {
        this.stop(event);
        this.setFilterOpen(false, true);
        return;
      }
      const layout = event.target.closest('[data-lh-sale-layout]');
      if (layout && this.results.contains(layout) && ['1', '2'].includes(layout.dataset.lhSaleLayout)) {
        this.stop(event);
        this.setMobileColumns(layout.dataset.lhSaleLayout);
        return;
      }
      const retry = event.target.closest('[data-lh-sale-retry]');
      if (retry && this.contains(retry)) {
        this.stop(event);
        if (this.failedRequest) this.load(this.failedRequest.url, this.failedRequest.options);
        return;
      }
      const anchor = event.target.closest('a[href]');
      if (!anchor || !this.contains(anchor) || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
      if (anchor.matches('[data-lh-sale-tab]')) {
        const url = new URL(anchor.href, location.origin);
        if (!this.isAllowed(url)) return;
        this.stop(event);
        url.search = '';
        this.load(url, { kind: 'tab' });
        return;
      }
      if (!this.results.contains(anchor)) return;
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const url = new URL(anchor.href, this.activeURL);
      if (!this.isAllowed(url)) return;
      // Product, swatch, quick-buy and collection cards keep their native behavior.
      if (anchor.closest('.collection-listing')) return;
      if (anchor.closest('.pagination-row')) {
        this.stop(event);
        const target = new URL(this.activeURL);
        for (const key of [...target.searchParams.keys()]) if (/^page(?:_|$)/.test(key)) target.searchParams.delete(key);
        for (const [key, value] of url.searchParams) if (/^page(?:_|$)/.test(key)) target.searchParams.append(key, value);
        this.load(target, { kind: 'page' });
      } else if (anchor.closest('.link-dropdown__options')) {
        this.stop(event);
        const target = new URL(this.activeURL);
        target.searchParams.set('sort_by', url.searchParams.get('sort_by') || 'manual');
        for (const key of [...target.searchParams.keys()]) if (/^page(?:_|$)/.test(key)) target.searchParams.delete(key);
        this.load(target, { kind: 'sort' });
      } else if (anchor.closest('[data-lh-sale-filter-panel]')) {
        this.stop(event);
        this.load(this.catalogURL(url), { kind: 'filter' });
      }
    }

    formURL(scope) {
      const target = new URL(this.activeURL);
      const controls = Array.from(scope.querySelectorAll('input[name],select[name]')).filter(control => isCatalogParam(control.name) && !/^page(?:_|$)/.test(control.name));
      const names = new Set(controls.map(control => control.name));
      names.forEach(name => target.searchParams.delete(name));
      for (const key of [...target.searchParams.keys()]) if (/^page(?:_|$)/.test(key)) target.searchParams.delete(key);
      const pairs = new Set();
      for (const control of controls) {
        if (control.disabled || (['checkbox', 'radio'].includes(control.type) && !control.checked)) continue;
        const values = control.tagName === 'SELECT' ? Array.from(control.selectedOptions, option => option.value) : [control.value];
        for (const value of values) {
          if (value === '') continue;
          const pair = JSON.stringify([control.name, value]);
          if (!pairs.has(pair)) target.searchParams.append(control.name, value);
          pairs.add(pair);
        }
      }
      const availability = controls.find(control => control.name === 'filter.v.availability' && control.value === '1');
      if (this.dataset.hideUnavailable === 'true' && availability && !target.searchParams.has('filter.v.availability')) {
        if ([...target.searchParams.keys()].some(name => name.startsWith('filter.'))) target.searchParams.set('filter.v.availability', '1');
      }
      return target;
    }

    validateForm(form) {
      const min = form.querySelector('[data-lh-sale-price-min]');
      const max = form.querySelector('[data-lh-sale-price-max]');
      min?.setCustomValidity('');
      max?.setCustomValidity('');
      if (min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
        max.setCustomValidity('Maximum price must be at least the minimum price.');
      }
      if (form.checkValidity && !form.checkValidity()) { form.reportValidity?.(); return false; }
      return true;
    }

    onChange(event) {
      const control = event.target;
      if (!(control instanceof Element) || !this.results.contains(control) || !isCatalogParam(control.name || '')) return;
      this.resultsDirty = true;
      this.stop(event);
      if (control.name === 'sort_by') {
        const target = new URL(this.activeURL);
        target.searchParams.set('sort_by', control.value);
        for (const key of [...target.searchParams.keys()]) if (/^page(?:_|$)/.test(key)) target.searchParams.delete(key);
        this.load(target, { kind: 'sort', focus: this.focusKey(control) });
        return;
      }
      // Price inputs are applied together with the Apply button, so typing a
      // minimum never replaces the maximum field midway through an edit.
      if (control.hasAttribute('data-lh-sale-price-min') || control.hasAttribute('data-lh-sale-price-max')) {
        control.setCustomValidity('');
        return;
      }
      const scope = control.closest('form') || this.results;
      if (!this.validateForm(scope)) return;
      this.load(this.formURL(scope), { kind: control.name === 'sort_by' ? 'sort' : 'filter', focus: this.focusKey(control) });
    }

    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof Element) || !this.results.contains(form) || !form.querySelector('[name^="filter."],[name="sort_by"]')) return;
      this.stop(event);
      if (!this.validateForm(form)) return;
      this.load(this.formURL(form), { kind: 'filter', closeFilters: window.matchMedia('(max-width: 767px)').matches });
    }

    onReset(event) {
      const form = event.target;
      if (!(form instanceof Element) || !this.results.contains(form) || !form.querySelector('[name^="filter."]')) return;
      this.stop(event);
      const target = new URL(this.activeURL);
      for (const key of [...target.searchParams.keys()]) {
        if (key.startsWith('filter.') || /^page(?:_|$)/.test(key)) target.searchParams.delete(key);
      }
      this.load(target, { kind: 'filter' });
    }

    focusKey(control) {
      return { id: control.id, name: control.name, value: control.value, type: control.type };
    }

    restoreFocus(key) {
      if (!key) return;
      const controls = Array.from(this.results.querySelectorAll('input,select,button,a'));
      const control = controls.find(node => key.id && node.id === key.id) || controls.find(node => node.name === key.name && node.type === key.type && (!['checkbox', 'radio'].includes(key.type) || node.value === key.value));
      control?.focus({ preventScroll: true });
    }

    copyUIState(incoming) {
      const detailState = new Map(Array.from(this.results.querySelectorAll('.lh-sale-filter-group[id]'), details => [details.id, details.open]));
      incoming.querySelectorAll('.lh-sale-filter-group[id]').forEach(details => {
        if (detailState.has(details.id)) details.open = detailState.get(details.id);
      });
      const oldGrid = this.results.querySelector('.product-grid');
      const newGrid = incoming.querySelector('.product-grid');
      if (oldGrid && newGrid) {
        const mobileClass = [...oldGrid.classList].find(name => /^product-grid--per-row-mob-[12]$/.test(name));
        if (mobileClass) {
          for (const name of [...newGrid.classList]) if (name.startsWith('product-grid--per-row-mob-')) newGrid.classList.remove(name);
          newGrid.classList.add(mobileClass);
          const twoColumns = mobileClass.endsWith('-2');
          incoming.querySelectorAll('[data-lh-sale-layout]').forEach(button => {
            const active = button.dataset.lhSaleLayout === (twoColumns ? '2' : '1');
            button.classList.toggle('layout-switch--active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        }
      }
    }

    parseResults(html, url) {
      // Template content has an inert owner document: speculative parsing must
      // not construct product widgets or activate images before a tab is shown.
      const template = document.createElement('template');
      template.innerHTML = html;
      const widget = Array.from(template.content.querySelectorAll('lahome-sale-collection-v5')).find(node => node.dataset.saleView === this.dataset.saleView);
      const incoming = widget?.querySelector('[data-lh-sale-results]');
      if (!incoming || !incoming.querySelector('.collection-listing')) throw new Error('Sale section not found');
      const actual = new URL(incoming.dataset.collectionUrl, location.origin);
      if (actual.origin !== url.origin || pathKey(actual) !== pathKey(url)) throw new Error('Wrong collection context');
      return incoming;
    }

    async fetchResults(url, signal, speculative = false) {
      // The alternate view keeps this section's settings even if other collections
      // retain their existing storefront templates. Full HTML is a read-only fallback.
      const modes = this.fullPageFallback.has(pathKey(url)) ? [false] : [true, false];
      for (const singleSection of modes) {
        const response = await fetch(this.endpoint(url, singleSection), { credentials: 'same-origin', cache: 'default', signal, priority: speculative ? 'low' : 'auto' });
        if (response.url) {
          const finalURL = new URL(response.url);
          if (finalURL.origin !== url.origin || pathKey(finalURL) !== pathKey(url)) throw new Error('Unexpected redirect');
        }
        if (!response.ok) {
          if (singleSection && response.status === 404) continue;
          throw new Error('HTTP ' + response.status);
        }
        const html = await response.text();
        if (speculative) await this.waitForPrefetchIdle(url, signal);
        if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
        try {
          const incoming = this.parseResults(html, url);
          if (!singleSection) this.fullPageFallback.add(pathKey(url));
          return incoming;
        }
        catch (error) { if (!singleSection) throw error; }
      }
      throw new Error('Missing collection results');
    }

    finishLoading() {
      clearTimeout(this.loadingDelay);
      clearTimeout(this.requestTimer);
      this.pendingURL = null;
      this.classList.remove('lh-sale-is-loading');
      this.results.removeAttribute('aria-busy');
      this.results.inert = false;
      this.tabs.forEach(tab => tab.classList.remove('is-pending'));
      this.scheduleWarmup();
    }

    syncPageURL(url, options) {
      const pageURL = this.pageURL(url);
      if (options.historyMode !== 'none' && pageURL.href !== location.href) {
        history.pushState(history.state, '', pageURL.href);
      }
      this.lastPageURL = location.href;
    }

    async load(raw, options = {}) {
      const url = this.catalogURL(raw);
      // Repeated clicks on the same pending tab share the request already running.
      if (this.pendingURL === url.href) return;
      this.cancelWarmup();

      // Clicking the displayed tab during another request means "stay here".
      // Cancel that request without fetching/rebuilding the cards already on screen.
      if (url.href === this.activeURL.href && !this.resultsDirty) {
        this.sequence += 1;
        this.request?.abort();
        this.cancelPrefetch();
        this.finishLoading();
        this.failedRequest = null;
        this.errorBox.hidden = true;
        this.selectTab(url);
        if (options.closeFilters) this.setFilterOpen(false, true);
        this.syncPageURL(url, options);
        this.status.textContent = this.dataset.loadedText;
        return;
      }
      const sequence = ++this.sequence;
      this.request?.abort();
      clearTimeout(this.requestTimer);
      clearTimeout(this.loadingDelay);
      clearTimeout(this.prefetchDelay);
      if (this.prefetch && this.prefetch.url !== url.href) this.cancelPrefetch();
      this.pendingURL = url.href;
      this.request = new AbortController();
      const request = this.request;
      const timer = setTimeout(() => request.abort(), 15000);
      this.requestTimer = timer;
      this.failedRequest = null;
      this.errorBox.hidden = true;
      // Cached returns usually finish before this delay: avoid flashing/dimming them.
      this.classList.remove('lh-sale-is-loading');
      this.loadingDelay = setTimeout(() => {
        if (sequence === this.sequence && this.pendingURL) this.classList.add('lh-sale-is-loading');
      }, 150);
      this.results.setAttribute('aria-busy', 'true');
      this.results.inert = true;
      this.status.textContent = this.dataset.loadingText;
      this.tabs.forEach(tab => tab.classList.toggle('is-pending', pathKey(new URL(tab.href)) === pathKey(url)));
      try {
        const incoming = await this.getResults(url, request.signal);
        if (sequence !== this.sequence || !this.isConnected || request.signal.aborted) return;
        this.copyUIState(incoming);
        const expires = this.domCache.get(this.cacheKey(url))?.expires || this.cacheEntry(url)?.expires || Date.now() + 60000;
        this.dropDOM(this.cacheKey(url));
        // Preserve the stable results wrapper and only park its children.
        // Detached panels cannot introduce duplicate IDs or focusable hidden cards.
        const outgoing = this.results.cloneNode(false);
        outgoing.inert = false;
        outgoing.removeAttribute('aria-busy');
        while (this.results.firstChild) outgoing.appendChild(this.results.firstChild);
        const fragment = document.createDocumentFragment();
        while (incoming.firstChild) fragment.appendChild(incoming.firstChild);
        this.results.replaceChildren(fragment);
        // A control may already show the next requested filter while the old
        // products are still displayed. Never cache that mismatched form state.
        if (!this.resultsDirty) this.rememberDOM(this.activeURL, outgoing, this.activeExpires);
        this.resultsDirty = false;
        this.activeExpires = expires;
        this.results.dataset.collectionUrl = incoming.dataset.collectionUrl;
        this.results.dataset.collectionTitle = incoming.dataset.collectionTitle;
        this.activeURL = url;
        this.selectTab(url);
        this.setFilterOpen(options.closeFilters ? false : this.filterOpen);
        this.syncPageURL(url, options);
        this.status.textContent = (incoming.dataset.collectionTitle || '') + ' — ' + this.dataset.loadedText;
        // Inserting into the live document upgrades custom elements automatically.
        this.results.inert = false;
        if (options.closeFilters) this.setFilterOpen(false, true);
        else this.restoreFocus(options.focus);
        if (options.kind === 'page') this.results.scrollIntoView({ block: 'start', behavior: 'auto' });
        this.dispatchEvent(new CustomEvent('lahome:sale:updated', { bubbles: true, detail: { sectionId: this.dataset.sectionId, collectionURL: url.href, container: this.results } }));
      } catch (error) {
        if (sequence !== this.sequence || !this.isConnected) return;
        this.failedRequest = { url, options };
        this.errorBox.hidden = false;
        this.status.textContent = this.dataset.errorText;
        if (options.historyMode === 'none' && this.lastPageURL !== location.href) history.replaceState(history.state, '', this.lastPageURL);
      } finally {
        clearTimeout(timer);
        if (sequence === this.sequence) this.finishLoading();
      }
    }

  }

  customElements.define('lahome-sale-collection-v5', LahomeSaleCollection);
})();


  } catch(e) { console.error(e); }
})();
})();
